import React from "react";
import { compareValues } from "@sscs/utils";
import { getPropertyLabel, normalizeActionName } from "../../../utils";
import { parseActionChange } from "../diffUtils";
import ChangeCategoryCard from "./ChangeCategoryCard";
import styles from "./diffChanges.module.scss";
const eventLine = (actionString, actionMappings, key) => {
    const parsed = parseActionChange(actionString);
    if (!parsed)
        return null;
    return (React.createElement("div", { key: key, className: styles["change-line"] },
        React.createElement("strong", null,
            normalizeActionName(parsed.onEvent),
            " (",
            parsed.eventName,
            ")"),
        ` · ${normalizeActionName(parsed.action)} · `,
        getPropertyLabel(actionMappings, parsed.action, parsed.propertyKey),
        `: ${parsed.propertyValue}`));
};
const EventChanges = ({ actions, actionMappings, }) => {
    const sortedActions = actions.toSorted((actionA, actionB) => compareValues(actionA.current || actionA.previous, actionB.current || actionB.previous, false));
    const added = [];
    const removed = [];
    sortedActions.forEach((change, index) => {
        if (change.change !== "removed")
            added.push(eventLine(change.current, actionMappings, `${index}-current`));
        if (change.change !== "added")
            removed.push(eventLine(change.previous, actionMappings, `${index}-previous`));
    });
    return (React.createElement(ChangeCategoryCard, { title: "Events", added: added.filter(Boolean), removed: removed.filter(Boolean) }));
};
export default EventChanges;
//# sourceMappingURL=EventChanges.js.map